import { FC } from 'react';
import { IsActiveBadge } from '@/features/IsActiveBadge';
import { getShortName } from '@/shared/lib';
import type { UserGroupMemberValue } from '../UsersGroupForm/types';

type Props = {
  user: UserGroupMemberValue;
};

/** Название пользователя в строке состава группы и в окне выбора: ФИО, роль и признак действия */
export const UserGroupMemberTitle: FC<Props> = ({ user }) => (
  <span>
    {getShortName(user.firstName, user.lastName, user.middleName)}
    {user.role?.name && <span className="text-sm text-muted-foreground ml-2">{user.role.name}</span>}
    <IsActiveBadge isActive={user.isActive} className="ml-3" />
  </span>
);
